import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgAvatarCrown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 19 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.009 12.54s.88-6.342 1.823-9.415l-4.758 3.553L9.832.541 5.589 6.678.832 3.125c.943 3.073 1.822 9.416 1.822 9.416l.405.064a43.18 43.18 0 0 0 13.95-.064Z"
      fill="#FFC700"
    />
  </svg>
);
const Memo = memo(SvgAvatarCrown);
export default Memo;
